'use client';

import { IconButton, Stack, Typography } from '@mui/material';

import Document from '@/components/SvgIcons/Document';
import Trash from '@/components/SvgIcons/Trash';
import colors from '@/styles/themes/colors';

import styles from './FilePreview.module.scss';

interface FilePreviewProps {
  file: File;
  onRemove: () => void;
}

const formatFileSize = (bytes: number): string => {
  const mb = bytes / (1024 * 1024);

  return `${mb.toFixed(1)} mB`;
};

const FilePreview = ({ file, onRemove }: FilePreviewProps) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" className={styles.container}>
    <Stack direction="row" alignItems="center" gap={1.5}>
      <Stack alignItems="center" justifyContent="center" className={styles.iconWrapper}>
        <Document fill={colors.graytone400} size={18} />
      </Stack>
      <Stack gap={0.5}>
        <Typography variant="body1" color={colors.white} className={styles.fileName}>
          {file.name}
        </Typography>
        <Typography variant="body2" color={colors.graytone500}>
          {formatFileSize(file.size)}
        </Typography>
      </Stack>
    </Stack>
    <IconButton
      onClick={e => {
        e.stopPropagation();
        onRemove();
      }}
      className={styles.removeButton}
      aria-label="Remove file"
    >
      <Trash fill={colors.graytone400} size={24} />
    </IconButton>
  </Stack>
);

export default FilePreview;
